import { useEffect, useState } from "react";
import { handleCatchErrors, resolver, responseDataFormat } from "../../../API/middlewares/resolveRequests";
import {
  getAllTaskMembers,
  getAllTaskStatus,
  getEditDataTaskForm,
  getTaskSearch,
  searchAllTasks,
  setTaskStatus,
} from "../../../API/store/actions/tasks";
import ModalComponent from "../../reusableComponents/modal";
import Bullets from "../../sharedComponents/bullets/bullets";
import Button from "../../sharedComponents/buttons/button";
import TaskStatusCard from "./taskStatusCard";
import "../tasksStyle.css";
import { useDispatch, useSelector } from "react-redux";
import DropDownList from "../../sharedComponents/dropdown/dropdown";
import Lang from "../../../userPreferences/staticWords";
import axios from "../../../API/axiosConfig";
import { error } from "jquery";
import { currentLanguage } from "../../../algorithms/storage";
import { searchTasks } from "../../../API/services/tasks";
const TaskStatus = ({
  taskId,
  taskTitle,
  userToken,
  procAdded,
  setProcAdded,
  setVisible
}) => {
  const [members, setMembers] = useState(null);
  const [status, setStatus] = useState(null);
  const [modalVisible, setModalVisible] = useState(null);
  const [projectStatus, setProjectStatus] = useState(null);
  const [StatusId, setStatusId] = useState(null);
  const [changeAll, setChangeAll] = useState(false);

  // const modalVisibleFunc = (id) => {
  //   setStatusId(id);
  //   setModalVisible(true);
  // };

  useEffect(() => {
    setTaskStatus(
      taskId,
      changeAll,
      projectStatus,
      resolver,
      getAllTaskMembers,
      setMembers,
      userToken
    );
  }, [projectStatus]);

  const communityTaskForm = useSelector(
    (state) => state.tasks.getCommunityTaskForm
  );

  const [TaskStatusDropdownList, setTaskStatusDropdownList] = useState(
    communityTaskForm?.data?.taskStatusLkp
  );
 const [data,setData] = useState(null)
 const [statusId, setStatusIdNumber] = useState()
  useEffect(() => {
    resolver(getAllTaskMembers, setMembers, taskId, userToken);
    resolver(getAllTaskStatus, setStatus, userToken);
      resolver(getEditDataTaskForm,setData,taskId,0,userToken);
  }, []);
useEffect(() => {
  if(data?.data){
    setStatusIdNumber(data?.data?.taskStatusId)
  }
},[data])
const [response, setResponse] = useState(null)
const handleSubmit = async (e) => {
  e.preventDefault()
  let response;
  try {
    response = await axios.put(`Task/SetTaskStatus/${taskId}/${statusId}/false`, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Accept-Language": currentLanguage(),
        Authorization: `Bearer ${userToken}`,
      },
    })
  } catch (e) {
    response = error;
  } finally {
    return setResponse(response);
  }
  
}
useEffect(() => {
  if (response?.data){
    if (response?.data?.status){
      setVisible(false)
      // searchAllTasks(0,1,20,{}, userToken)
       window.location.reload();
    }
  }
},[response])


  return (
    <>
      <ModalComponent
        body={
          <TaskStatusAlert
            id={StatusId}
            setValue={setProjectStatus}
            setVisible={setModalVisible}
            setChangeAll={setChangeAll}
            procAdded={procAdded}
            setProcAdded={setProcAdded}
          />
        }
        size={"s"}
        modalVisible={modalVisible}
        setModalVisible={setModalVisible}
        hasIcon
        title={"هل انت متاكد"}
        background={"modalBackground mx-5"}
      />
      <div className="mx-5 ">
        <form onSubmit={(e) => handleSubmit(e)}>
        <DropDownList
          placeholder={Lang.taskStatus + "*"}
          border={true}
          containerStyle={`col-12 mb-3 mb-xl-1 col-xl-12 mx-0 ps-2 pe-2 `}
          dataSource={TaskStatusDropdownList}
          value={statusId}
          change={(e) => {
            setStatusIdNumber(e?.value)
          }}
        />
        <div className="status-submit mt-5 mb-3 text-center">
          <button className="custom_btn solid" type="submit" style={{width:"150px", height:"55px"}}>حفظ</button>
        </div>
        </form>
        {/* <div className="d-flex flex-column flex-lg-row justify-content-between mx-3">
          <div style={{ fontSize: 18 }}>{taskTitle}</div>
          <div className="d-flex align-items-center justify-content-center col-lg-3 col-12 mt-lg-0 mt-4">
            {status?.data?.taskStatusLkp.map((item, index) => {
              return (
                <div className=" d-flex flex-column justify-content-center align-items-center mx-2">
                  <Bullets
                    key={index}
                    containerStyle={{ width: 21 }}
                    memberId={taskId}
                    id={item.id}
                    borderColor={"#1a73e8"}
                    bulletColor={item?.color}
                    tooltipTitle={item.name}
                    setActive={modalVisibleFunc}
                    active={projectStatus ?? members?.data?.taskStatusId}
                    procAdded={procAdded}
                    setProcAdded={setProcAdded}
                  />

                  <div className=" text-center">{item.name} </div>
                </div>
              );
            })}
          </div>
        </div> */}
        {/* {members?.data?.adminmember?.length > 0 ||
        members?.data?.member?.length > 0 ? (
          <div
            className="my-3  px-2"
            style={{
              boxShadow: "1px 2px 7px grey",
              height: 400,
              overflowY: "auto",
            }}
          >
            <div className="p-3" style={{ color: "#1a73e8" }}>
              المشاركين
            </div>

            {members?.data?.adminmember?.length > 0 ? (
              <div className="px-5 ">
                <div className="my-3">المشاركين الرئيسيين</div>
                {members?.data?.adminmember.map((item, index) => {
                  return (
                    <TaskStatusCard
                      key={index}
                      procAdded={procAdded}
                      setProcAdded={setProcAdded}
                      member={item}
                      status={status}
                    />
                  );
                })}
              </div>
            ) : null}
            {members?.data?.member?.length > 0 ? (
              <div className="px-5 ">
                <div className="my-3">المشاركين </div>
                {members?.data?.member.map((item, index) => {
                  return (
                    <TaskStatusCard
                      key={index}
                      procAdded={procAdded}
                      setProcAdded={setProcAdded}
                      member={item}
                      status={status}
                    />
                  );
                })}
              </div>
            ) : null}
          </div>
        ) : null} */}
      </div>
    </>
  );
};

export default TaskStatus;

const TaskStatusAlert = ({ setVisible, setValue, id, setChangeAll }) => {
  const dispatch = useDispatch();
  return (
    <div className=" d-flex flex-column  align-items-center justify-content-center">
      <img src="/assets/images/fi-br-info.png" />
      <div className="my-2">هل تريد تغيير حالة المشاركين أيضًا ؟ </div>
      <div className="d-flex justify-content-center flex-wrap w-100 my-3">
        <Button
          containerStyle={"col-3 mx-2 "}
          content={"نعم"}
          buttonStyleType={"solid"}
          onClick={() => {
            setValue(id);
            dispatch({ type: "RELOAD" });
            setVisible(false);
            setChangeAll(true);
          }}
        />
        <Button
          containerStyle={"col-3 mx-2"}
          content={"لا"}
          onClick={() => {
            setValue(id);
            dispatch({ type: "RELOAD" });
            setVisible(false);
            setChangeAll(false);
          }}
        />
      </div>
    </div>
  );
};
